import React, { useEffect, useMemo } from 'react';
import { Input } from '@iq/react-components';

import config from '../../../config';
import Tooltip from '../../Tooltip/Tooltip';
import SelectPollingDateRange from '../../SelectPollingDateRange';
import { EVENT_TYPE_USER } from '../../../constants';
import { useDateDomain, useFilterText, useSelectedEventType } from './EventTimelineState';
import TypeSpecificEventFilters from './TypeSpecificEventFilters';

const ONE_WEEK_IN_MS = 7 * 24 * 60 * 60 * 1000 + 1000 * 60; // 7 days + 1 minute buffer to account for rounding errors

const EventFilters = ({
  panelId,
  enableGlobalDates = true,
  availableIotEventTypes,
  availableUserEventTypes,
  site,
}) => {
  const [filterText, onChangeFilterText] = useFilterText('');
  const [selectedEventType] = useSelectedEventType();
  const dateDomain = useDateDomain();
  const stringifiedDateDomain = JSON.stringify(dateDomain);

  const isWideRange = useMemo(() => {
    const parsedDomain = JSON.parse(stringifiedDateDomain);
    if (!Array.isArray(parsedDomain) || parsedDomain.length < 2) {
      return false;
    }

    const [from, to] = parsedDomain;
    if (!from || !to) {
      return false;
    }
    const domainMs = Number(to) - Number(from);

    return domainMs > ONE_WEEK_IN_MS;
  }, [stringifiedDateDomain]);

  const isSearchDisabled = config.onPremise && selectedEventType !== EVENT_TYPE_USER && isWideRange;

  useEffect(() => {
    if (isSearchDisabled && filterText) {
      onChangeFilterText('');
    }
  }, [filterText, isSearchDisabled, onChangeFilterText]);

  const filterValue = useMemo(
    () => (isSearchDisabled ? '' : filterText || ''),
    [filterText, isSearchDisabled]
  );

  return (
    <div className="event-timeline-filters">
      {panelId && (
        <SelectPollingDateRange
          panelId={panelId}
          enableGlobalDates={enableGlobalDates}
        />
      )}
      <Tooltip
        content={
          isSearchDisabled ? 'Search is only available in timeframes under 1 week.' : undefined
        }
        disabled={!isSearchDisabled}
      >
        <div className="event-timeline-search">
          <Input
            type="text"
            placeholder="Search..."
            value={filterValue}
            onChange={onChangeFilterText}
            disabled={isSearchDisabled}
          />
        </div>
      </Tooltip>
      <TypeSpecificEventFilters
        panelId={panelId}
        availableIotEventTypes={availableIotEventTypes}
        availableUserEventTypes={availableUserEventTypes}
        site={site}
      ></TypeSpecificEventFilters>
    </div>
  );
};

export default EventFilters;
